// import React, { useRef, useEffect, useState } from "react";
// import { MapContainer, TileLayer, Polyline, Marker, Popup, LayersControl, LayerGroup } from "react-leaflet";
// import { EditButton } from "react-admin";
// import { Button } from "@material-ui/core";
// import SettingsRemote from "@material-ui/icons/SettingsRemote";
// import { PlateViewItem } from "../components/PlateViewItem";
// import { getBearing, getVehicleIcon } from "../utils/vehicleUtils";
// import { useCurrentBearing } from "../hooks/useCurrentBearing";
// import { _log } from "../utils/logUtils";
// import { getCoordinates, getLatestCoordinate, calculateDistance, getLatLon, easeInOutCubic, initialBounds, POLYLINE_COLORS } from "../utils/logUtils";
// import "leaflet-rotatedmarker";
// import L from "leaflet";
// import "leaflet-fullscreen/dist/Leaflet.fullscreen.js";
// import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
// import "leaflet/dist/leaflet.css";

// function usePrevious(value) {
//     const ref = useRef();
//     useEffect(() => {
//         ref.current = value;
//     });
//     return ref.current;
// }

// const AnimatedMarker = ({ vehicle, onIsolate, userLocation, duration = 2000, position, calculatedBearing, ...props }) => {
//     const markerRef = useRef();
//     const animationRef = useRef();
//     const prevPosition = usePrevious(position);

//     useEffect(() => {
//         const marker = markerRef.current;
//         const positionChanged = marker && prevPosition && JSON.stringify(position) !== JSON.stringify(prevPosition);

//         if (positionChanged) {
//             if (animationRef.current) cancelAnimationFrame(animationRef.current);

//             const startTime = performance.now();
//             const startPosition = prevPosition;

//             const animate = currentTime => {
//                 const elapsed = currentTime - startTime;
//                 let progress = Math.min(elapsed / duration, 1);
//                 const easedProgress = easeInOutCubic(progress);

//                 const lat = startPosition[0] + (position[0] - startPosition[0]) * easedProgress;
//                 const lng = startPosition[1] + (position[1] - startPosition[1]) * easedProgress;

//                 marker.setLatLng([lat, lng]);

//                 if (progress < 1) {
//                     animationRef.current = requestAnimationFrame(animate);
//                 }
//             };

//             animationRef.current = requestAnimationFrame(animate);
//         }

//         return () => {
//             if (animationRef.current) cancelAnimationFrame(animationRef.current);
//         };
//     }, [position, duration, prevPosition]);

//     const [initialBearing] = useState(() => Math.random() * 360);
//     const targetBearing = calculatedBearing !== null ? calculatedBearing : initialBearing;
//     const animatedBearing = useCurrentBearing(targetBearing);

//     useEffect(() => {
//         if (markerRef.current) {
//             markerRef.current.setRotationAngle(animatedBearing);
//         }
//     }, [animatedBearing]);

//     const distanceInKm = calculateDistance(userLocation, getLatLon(vehicle.lastLocation));

//     return (
//         <Marker ref={markerRef} position={position} {...props}>
//             <Popup>
//                 <PlateViewItem
//                     key={vehicle.id}
//                     vehicle={{
//                         ...vehicle,
//                         distance: distanceInKm,
//                     }}
//                     onToggle={null}
//                     isSelected={true}
//                 />
//                 <EditButton basePath="/assets" label="Controls" record={vehicle} icon={<SettingsRemote />} />
//                 <Button style={{ marginLeft: "8px" }} onClick={() => onIsolate(vehicle.id)}>
//                     SELECT
//                 </Button>
//             </Popup>
//         </Marker>
//     );
// };

// export const MapDisplay = React.memo(({ visibleVehicles, todayLogs, yesterdayLogs, oldLogs, onIsolate, userLocation, setMap, selectedLayer, setSelectedLayer, userId }) => {
//     return (
//         <MapContainer whenCreated={setMap} bounds={initialBounds} scrollWheelZoom={true} style={{ height: "100%" }}>
//             <LayersControl position="bottomright">
//                 <LayersControl.BaseLayer checked={selectedLayer === "Satellite Only View"} name="Satellite Only View">
//                     <TileLayer attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer checked={selectedLayer === "OpenStreetMap"} name="OpenStreetMap">
//                     <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer checked={selectedLayer === "Dark Mode (CartoDB)"} name="Dark Mode (CartoDB)">
//                     <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer checked={selectedLayer === "Topographic Map"} name="Topographic Map">
//                     <TileLayer
//                         attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
//                         url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
//                     />
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer checked={selectedLayer === "Humanitarian Style"} name="Humanitarian Style">
//                     <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a>' url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png" />
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer checked={selectedLayer === "Roads & Borders"} name="Roads & Borders">
//                     <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png" />
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer checked={selectedLayer === "Street Map"} name="Street Map">
//                     <TileLayer attribution="Google Maps" url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}" />
//                 </LayersControl.BaseLayer>
//                 <LayersControl.BaseLayer checked={selectedLayer === "Hybrid"} name="Hybrid">
//                     <LayerGroup>
//                         <TileLayer attribution="Google Maps Satellite" url="https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}" />
//                         <TileLayer url="https://www.google.cn/maps/vt?lyrs=y@189&gl=cn&x={x}&y={y}&z={z}" />
//                     </LayerGroup>
//                 </LayersControl.BaseLayer>
//             </LayersControl>

//             {visibleVehicles.map(vehicle => {
//                 // Combine logs for the selected vehicle to determine the latest coordinate.
//                 // If more than one vehicle is visible, we don't show trails, so logs stay empty.
//                 const isSelected = visibleVehicles.length === 1;
//                 // const isSelected = vehicle.id === focusedId;
//                 const combinedLogs = isSelected ? [...oldLogs, ...yesterdayLogs, ...todayLogs] : [];

//                 return (
//                     <React.Fragment key={vehicle.id}>
//                         <AnimatedMarker
//                             vehicle={vehicle}
//                             onIsolate={onIsolate}
//                             userLocation={userLocation}
//                             icon={getVehicleIcon(vehicle, userId)}
//                             position={getCoordinates(getLatestCoordinate(vehicle, combinedLogs))}
//                             // calculatedBearing={getBearing(vehicle.log?.[vehicle.log.length - 2]?.coordinate, vehicle.log?.[vehicle.log.length - 1]?.coordinate)}
//                             calculatedBearing={getBearing(todayLogs?.[todayLogs.length - 2]?.coordinate, todayLogs?.[todayLogs.length - 1]?.coordinate)}
//                             rotationOrigin="center"
//                             duration={3000}
//                         />

//                         {isSelected && (
//                             <>
//                                 <Polyline pathOptions={{ color: POLYLINE_COLORS.OLD, stroke: true, weight: 5 }} positions={oldLogs.map(p => getCoordinates(p.coordinate))} />
//                                 <Polyline pathOptions={{ color: POLYLINE_COLORS.YESTERDAY, stroke: true, weight: 5 }} positions={yesterdayLogs.map(p => getCoordinates(p.coordinate))} />
//                                 <Polyline pathOptions={{ color: POLYLINE_COLORS.TODAY, stroke: true, weight: 5 }} positions={todayLogs.map(p => getCoordinates(p.coordinate))} />
//                             </>
//                         )}
//                     </React.Fragment>
//                 );
//             })}
//         </MapContainer>
//     );
// });
import React, { useRef, useEffect, useState } from "react";
import { MapContainer, TileLayer, Polyline, Marker, Popup, LayersControl, LayerGroup } from "react-leaflet";
import { EditButton } from "react-admin";
import { Button } from "@material-ui/core";
import SettingsRemote from "@material-ui/icons/SettingsRemote";
import { PlateViewItem } from "../components/PlateViewItem";
import { getBearing, getVehicleIcon } from "../utils/vehicleUtils";
import { useCurrentBearing } from "../hooks/useCurrentBearing";
import { _log } from "../utils/logUtils";
import { getCoordinates, getLatestCoordinate, calculateDistance, getLatLon, easeInOutCubic, initialBounds, POLYLINE_COLORS } from "../utils/logUtils";
import "leaflet-rotatedmarker";
import L from "leaflet";
import "leaflet-fullscreen/dist/Leaflet.fullscreen.js";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import "leaflet/dist/leaflet.css";

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const AnimatedMarker = ({ vehicle, onIsolate, userLocation, duration = 2000, position, calculatedBearing, ...props }) => {
    const markerRef = useRef();
    const animationRef = useRef();
    const prevPosition = usePrevious(position);

    useEffect(() => {
        const marker = markerRef.current;
        const positionChanged = marker && prevPosition && JSON.stringify(position) !== JSON.stringify(prevPosition);

        if (positionChanged) {
            if (animationRef.current) cancelAnimationFrame(animationRef.current);

            const startTime = performance.now();
            const startPosition = prevPosition;

            const animate = currentTime => {
                const elapsed = currentTime - startTime;
                let progress = Math.min(elapsed / duration, 1);
                const easedProgress = easeInOutCubic(progress);

                const lat = startPosition[0] + (position[0] - startPosition[0]) * easedProgress;
                const lng = startPosition[1] + (position[1] - startPosition[1]) * easedProgress;

                marker.setLatLng([lat, lng]);

                if (progress < 1) {
                    animationRef.current = requestAnimationFrame(animate);
                }
            };

            animationRef.current = requestAnimationFrame(animate);
        }

        return () => {
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };
    }, [position, duration, prevPosition]);

    const [initialBearing] = useState(() => Math.random() * 360);
    const targetBearing = calculatedBearing !== null ? calculatedBearing : initialBearing;
    const animatedBearing = useCurrentBearing(targetBearing);

    useEffect(() => {
        if (markerRef.current) {
            markerRef.current.setRotationAngle(animatedBearing);
        }
    }, [animatedBearing]);

    const distanceInKm = calculateDistance(userLocation, getLatLon(vehicle.lastLocation));

    return (
        <Marker ref={markerRef} position={position} {...props}>
            <Popup maxWidth={280} minWidth={280}>
                <div>
                    <PlateViewItem
                        key={vehicle.id}
                        vehicle={{
                            ...vehicle,
                            distance: distanceInKm,
                        }}
                        onToggle={null}
                        isSelected={true}
                    />
                    <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>
                        <EditButton basePath="/assets" label="Controls" record={vehicle} icon={<SettingsRemote />} variant="outlined" style={{ height: "40px", flex: 1, borderRadius: "8px" }} />
                        <Button variant="contained" color="primary" style={{ height: "40px", flex: 1, borderRadius: "8px", fontSize: "12px", fontWeight: "bold" }} onClick={() => onIsolate(vehicle.id)}>
                            SELECT
                        </Button>
                    </div>
                </div>
            </Popup>
        </Marker>
    );
};

export const MapDisplay = React.memo(({ visibleVehicles, todayLogs, yesterdayLogs, oldLogs, onIsolate, userLocation, setMap, selectedLayer, setSelectedLayer, userId }) => {
    return (
        <>
            <style>{`
                .leaflet-popup-content-wrapper { border-radius: 10px; padding: 0; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.15); }
                .leaflet-popup-content { margin: 12px; }
            `}</style>
            <MapContainer whenCreated={setMap} bounds={initialBounds} scrollWheelZoom={true} style={{ height: "100%" }}>
                <LayersControl position="bottomright">
                    <LayersControl.BaseLayer checked={selectedLayer === "Satellite Only View"} name="Satellite Only View">
                        <TileLayer attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer checked={selectedLayer === "OpenStreetMap"} name="OpenStreetMap">
                        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer checked={selectedLayer === "Dark Mode (CartoDB)"} name="Dark Mode (CartoDB)">
                        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer checked={selectedLayer === "Topographic Map"} name="Topographic Map">
                        <TileLayer
                            attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
                            url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer checked={selectedLayer === "Humanitarian Style"} name="Humanitarian Style">
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
                            url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer checked={selectedLayer === "Roads & Borders"} name="Roads & Borders">
                        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png" />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer checked={selectedLayer === "Street Map"} name="Street Map">
                        <TileLayer attribution="Google Maps" url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}" />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer checked={selectedLayer === "Hybrid"} name="Hybrid">
                        <LayerGroup>
                            <TileLayer attribution="Google Maps Satellite" url="https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}" />
                            <TileLayer url="https://www.google.cn/maps/vt?lyrs=y@189&gl=cn&x={x}&y={y}&z={z}" />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                </LayersControl>

                {visibleVehicles.map(vehicle => {
                    const isSelected = visibleVehicles.length === 1;
                    const combinedLogs = isSelected ? [...oldLogs, ...yesterdayLogs, ...todayLogs] : [];

                    return (
                        <React.Fragment key={vehicle.id}>
                            <AnimatedMarker
                                vehicle={vehicle}
                                onIsolate={onIsolate}
                                userLocation={userLocation}
                                icon={getVehicleIcon(vehicle, userId)}
                                position={getCoordinates(getLatestCoordinate(vehicle, combinedLogs))}
                                calculatedBearing={getBearing(todayLogs?.[todayLogs.length - 2]?.coordinate, todayLogs?.[todayLogs.length - 1]?.coordinate)}
                                rotationOrigin="center"
                                duration={3000}
                            />

                            {isSelected && (
                                <>
                                    <Polyline pathOptions={{ color: POLYLINE_COLORS.OLD, stroke: true, weight: 5 }} positions={oldLogs.map(p => getCoordinates(p.coordinate))} />
                                    <Polyline pathOptions={{ color: POLYLINE_COLORS.YESTERDAY, stroke: true, weight: 5 }} positions={yesterdayLogs.map(p => getCoordinates(p.coordinate))} />
                                    <Polyline pathOptions={{ color: POLYLINE_COLORS.TODAY, stroke: true, weight: 5 }} positions={todayLogs.map(p => getCoordinates(p.coordinate))} />
                                </>
                            )}
                        </React.Fragment>
                    );
                })}
            </MapContainer>
        </>
    );
});
